export const configApi = {
	apiUrl: "https://api-migracion.ticketshop.com.co/api/", // Servidor Final
	//apiUrl: "https://apicli-col.ticketsshop.com.co/api/", // Servidor de pruebas
	//apiUrl: 'https://test-api.ticketsshop.com.co/api/' // Servidor de pruebas
};
